import { useMemo } from "react";
import { useLang } from "@/lib/i18n";
import QuizEngine from "@/components/games/QuizEngine";

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

function shuffle(a) {
  const arr = [...a];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export default function AlphabetMatch({ onFinish }) {
  const questions = useMemo(() => {
    const chosen = shuffle(LETTERS).slice(0, 8);
    return chosen.map((L) => {
      const distractors = shuffle(LETTERS.filter((x) => x !== L)).slice(0, 2);
      const opts = shuffle([L, ...distractors]).map((x) => x.toLowerCase());
      return {
        promptNode: (
          <div className="mx-auto mb-4 flex h-28 w-28 items-center justify-center rounded-3xl bg-gradient-to-br from-[#E8F5FF] to-white text-6xl font-extrabold text-[#147DEB] ring-2 ring-[#147DEB]/15">
            {L}
          </div>
        ),
        options: opts,
        answer: opts.indexOf(L.toLowerCase()),
      };
    });
  }, []);
  return <QuizEngine questions={questions} onFinish={onFinish} />;
}
